import './search-bar.styles.scss';

const SearchBar = ({ handleSubmit }) => {
  return (
    <div className='search-bar'>
      <form onSubmit={handleSubmit}>
        <div class='form__group field'>
          <input
            type='input'
            class='form__field'
            placeholder='Search'
            name='loc'
            id='name'
          />
          <label for='name' class='form__label'>
            Search
          </label>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
